import { connect } from 'react-redux';

import ChangeboardingManagerComponent from './ChangeboardingManagerComponent.js';
import { getCurrentSpotlightId } from './selectors.js';

const mapStateToProps = (state) => ({
	spotlightId: getCurrentSpotlightId(state.views.changeboarding),
});

const ChangeboardingManager = connect(mapStateToProps)(ChangeboardingManagerComponent);

export default ChangeboardingManager;
